import { render, staticRenderFns } from "./ActivityEdit.vue?vue&type=template&id=5b486238&scoped=true"
import script from "./ActivityEdit.vue?vue&type=script&lang=js"
export * from "./ActivityEdit.vue?vue&type=script&lang=js"
import style0 from "./ActivityEdit.vue?vue&type=style&index=0&id=5b486238&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b486238",
  null
  
)

export default component.exports